import React from 'react'
import get from 'lodash/get'
import TriggerOnNavigate from './TriggerOnNavigate'
import useRouter from '../hooks/use-router'

function CurrentRouteComponent ({ component }) {
  const router = useRouter()

  React.useLayoutEffect(() => {
    if (component !== null && !!location.hash) {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      if (typeof (window.requestAnimationFrame) === 'function') {
        window.requestAnimationFrame(() => {
          setTimeout(() => {
            window.requestAnimationFrame(() => {
              const hash = location.hash
              const id = hash.replace('#', '')

              if (!id) {
                return
              }

              const element = document.getElementById(id)

              if (element && typeof (element.scrollIntoView) === 'function') {
                element.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' })
              }
            })
          }, 1000)
        })
      }
    }
  })

  if (component === null) {
    return null
  }

  const Component = get(router.components, component) || null

  return (
    <>
      <Component />
      <TriggerOnNavigate />
    </>
  )
}

export default CurrentRouteComponent
